import React from 'react'
import map from 'lodash/map'
import styled from 'styled-components'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import withTranslator from '../HOCComponents/withTranslator'
import { surfaces } from '../../theme'

// The keys step back so the values, what the click was for, read first.
const Key = styled.div`
  font-weight: 400;
  margin-bottom: 5px;
  color: ${props => props.color || themeColors.whiteTransparent06};
`

const Value = styled.div`
  color: ${themeColors.whiteColor};
  margin-left: auto;
`
const ListItem = styled.div`
  display: flex;
  align-items: baseline;
  & > div:not(:last-child) {
    margin-right: 1rem;
  }
`
// The map tooltips' look: deep navy, the mint contour inside the box, 8px corners and a floating shadow.
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.color || themeColors.whiteColor};
  border-radius: 8px;
  box-shadow: ${surfaces.mapPanelShadow};
  position: absolute;
  padding: 10px 15px;
  top: ${props => props.top};
  left: ${props => props.left};
  z-index: 10000;
`

const List = ({ properties, position, t }) => {
  return (
    <Wrapper left={position[1]} top={position[0]} color={themeColors.deepblueColor3}>
      {map(properties, (value, key) => {
        return (
          <ListItem key={key}>
            <Key>{t(key)}</Key>
            <Value>{t(value)}</Value>
          </ListItem>
        )
      })}
    </Wrapper>
  )
}

export default withTranslator(List)
